import PropTypes from 'prop-types';
import React from 'react';

import TenantPlatforms from '../../../../model/TenantPlatforms';
import useEnumerableModel from '../../../data/hooks/useEnumerableModel';
import itemIdValue from '../../../itemIdValue';
import useT from '../../utils/Translations/useT';
import MultiselectFilter from './MultiselectFilter';

const TenantPlatformSelector = props => {
  const t = useT();

  const { options } = useEnumerableModel(TenantPlatforms);

  return (
    <MultiselectFilter
      itemId={itemIdValue}
      options={options}
      title={t('Platform')}
      {...props}
    />
  );
};

TenantPlatformSelector.propTypes = {
  value: PropTypes.arrayOf(PropTypes.oneOf(TenantPlatforms.BasicValues)),
  onChange: PropTypes.func,
};

TenantPlatformSelector.defaultProps = {
  value: null,
  onChange: null,
};

export default TenantPlatformSelector;
